import * as moment from 'moment-timezone';

export class TimezoneStorage {

  public static store(timezone: string) {
    localStorage.setItem('timezone', timezone || moment.tz.guess());
  }

  public static get(): string {
    return localStorage.getItem('timezone') || moment.tz.guess();
  }

  public static has(): boolean {
    return !!localStorage.getItem('timezone');
  }
}
